module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"Name":"Nom du programmeur"}}')
  delete Component.options._Ctor
}
